<template>
  <section class="azul1">
    <v-container id="container" class="py-15">
      <v-row align="center" justify="center" class="my-md-15">
        <v-col cols="10" class="pa-5">
          <h2 class="font-weight-bold mb-4 primary--text">
            Politica y privacidad
          </h2>
          <div class="hr accent"></div>
          <h3 class="mt-15 text-uppercase primary--text">1. INFORMACIÓN AL USUARIO</h3>
          <p class="font-weight-light mt-4 primary--text">
            <strong>Ntec Web, S.L. </strong> , como Responsable
            del Tratamiento, le informa que, según lo dispuesto en el Reglamento
            (UE) 2016/679, de 27 de abril, (RGPD) y en la L.O. 3/2018, de 5 de
            diciembre, de protección de datos y garantía de los derechos
            digitales (LOPDGDD), trataremos su datos tal y como reflejamos en la
            presente Política de Privacidad. <br /><br />
            En esta Política de Privacidad describimos cómo recogemos sus datos
            personales y por qué los recogemos, qué hacemos con ellos, con quién
            los compartimos, cómo los protegemos y sus opciones en cuanto al
            tratamiento de sus datos personales.
            <br /><br />
            Esta Política se aplica al tratamiento de sus datos personales
            recogidos por la empresa para la prestación de sus servicios. Si
            acepta las medidas de esta Política, acepta que tratemos sus datos
            personales como se define en esta Política.
          </p>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h3 class="mt-4 text-uppercase primary--text">2. CONTACTO</h3>
          <v-list dense class="transparent">
            <v-list-item>
              <v-list-item-text>
                <p class="font-weight-light mt-4 primary--text">
                  Denominación social:
                  <strong> Ntec Web, S.L.</strong>
                </p>
              </v-list-item-text>
            </v-list-item>
            <v-list-item>
              <v-list-item-text>
                <p class="font-weight-light primary--text">
                  Nombre comercial: <strong> Ntec Web </strong>
                </p>
              </v-list-item-text>
            </v-list-item>
            <v-list-item>
              <v-list-item-text>
                <p class="font-weight-light primary--text">
                  Domicilio:
                  <strong
                    >Pol.Mutilva E-1, Planta baja. Oficina 0D 31192 (Navarra)
                  </strong>
                </p>
              </v-list-item-text>
            </v-list-item>
            <v-list-item>
              <v-list-item-text>
                <p class="font-weight-light primary--text">
                  e-mail: <strong> info@ntecweb.es </strong>
                </p>
              </v-list-item-text>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h3 class="my-4 text-uppercase primary--text">3. PRINCIPIOS CLAVE</h3>
          <p class="font-weight-light primary--text">
            Siempre hemos estado comprometidos con prestar nuestros servicios
            con el más alto grado de calidad, lo que incluye tratar sus datos
            con seguridad y transparencia. Nuestros principios son:
          </p>
          <v-list dense color="transparent">
            <p class="font-weight-light mt-4 primary--text">
              <v-list-item-group>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Legalidad: </strong> Solo recopilaremos sus Datos
                    personales para fines específicos, explícitos y legítimos.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Minimización de datos: </strong> Limitamos la
                    recogida de datos de carácter personal a lo que es
                    estrictamente relevante y necesario para los fines para los
                    que se han recopilado.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Limitación de la Finalidad: </strong> Solo
                    recogeremos sus datos personales para los fines declarados y
                    solo según sus deseos.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Precisión: </strong> Mantendremos sus datos
                    personales exactos y actualizados.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Seguridad de los Datos: </strong> Aplicamos las
                    medidas técnicas y organizativas adecuadas y proporcionales
                    a los riesgos para garantizar que sus datos no sufran daños,
                    tales como divulgación o acceso no autorizado, la
                    destrucción accidental o ilícita o su pérdida accidental o
                    alteración y cualquier otra forma de tratamiento ilícito.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Acceso y Rectificación: </strong> Disponemos de
                    medios para que acceda o rectifique sus datos cuando lo
                    considere oportuno.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Conservación: </strong> Conservamos sus datos
                    personales de manera legal y apropiada y solo mientras es
                    necesario para los fines para los que se han recopilado.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Las transferencias internacionales: </strong> Cuando
                    se dé el caso de que sus datos vayan a ser transferidos
                    fuera de la UE/EEE se protegerán adecuadamente.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Terceros: </strong> El acceso y transferencia de
                    datos personales a terceros se llevan a cabo de acuerdo con
                    las leyes y reglamentos aplicables y con las garantías
                    contractuales adecuadas.
                  </v-list-item-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-circle-medium </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    <strong>Marketing Directo y cookies: </strong>Cumplimos con
                    la legislación aplicable en materia de publicidad y cookies.
                  </v-list-item-text>
                </v-list-item>
              </v-list-item-group>
            </p>
          </v-list>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h3 class="my-4 text-uppercase primary--text">
            4. RECOGIDA Y TRATAMIENTO DE SUS DATOS PERSONALES
          </h3>
          <p class="font-weight-light primary--text">
            Los tipos de datos que se pueden solicitar y tratar son:
          </p>
          <v-list dense color="transparent">
            <p class="font-weight-light primary--text">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Datos de carácter identificativo.
                </v-list-item-text>
              </v-list-item>
            </p>
          </v-list>
          <p class="font-weight-light primary--text">
            También recogemos de forma automática datos sobre su visita a
            nuestro sitio web según se describe en la política de cookies.
            <br /><br />
            Siempre que solicitemos sus Datos personales, le informaremos con
            claridad de qué datos personales recogemos y con qué fin. En
            general, recogemos y tratamos sus datos personales con el propósito
            de:
          </p>
          <v-list dense color="transparent">
            <p class="font-weight-light primary--text">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Proporcionar información, servicios, productos, información
                  relevante y novedades en el sector.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text> Envío de comunicaciones. </v-list-item-text>
              </v-list-item>
            </p>
          </v-list>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h3 class="my-4 text-uppercase primary--text">5. LEGITIMIDAD</h3>
          <p class="font-weight-light primary--text">
            De acuerdo con la normativa de protección de datos aplicable, sus
            datos personales podrán tratarse siempre que:
          </p>
          <v-list dense color="transparent">
            <p class="font-weight-light primary--text">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Nos ha dado su consentimiento a los efectos del tratamiento.
                  Por supuesto podrá retirar su consentimiento en cualquier
                  momento.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text> Por requerimiento legal. </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Por exisitr un interés legítimo que no se vea menoscabado por
                  sus derechos de privacidad, como por ejemplo el envío de
                  información comercial bien por suscripción a nuestra
                  newsletter o por su condición de cliente.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Por se necesaria para la prestación de alguno de nuestros
                  servicios mediante relación contractual entre usted y
                  nosotros.
                </v-list-item-text>
              </v-list-item>
            </p>
          </v-list>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h3 class="my-4 primary--text">
            6. COMUNICACIÓN DE DATOS PERSONALES
          </h3>
          <p class="font-weight-light primary--text">
            Los datos pueden ser comunicados a empresas relacionadas con Urdi
            Nuevas Tecnologias, S.L. para la prestación de los diversos
            servicios en calidad de Encargados del Tratamiento. La empresa no
            realizará ninguna cesión, salvo por obligación legal.
          </p>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h3 class="my-4 primary--text">7. SUS DERECHOS</h3>
          <p class="font-weight-light primary--text">
            En relación con la recogida y tratamiento de sus datos personales,
            puede ponerse en contacto con nosotros en cualquier momento para:
          </p>
          <v-list dense color="transparent">
            <p class="font-weight-light primary--text">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Acceder a sus datos personales y a cualquier otra información
                  indicada en el Artículo 15.1 del RGPD.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Rectificar sus datos personales que sean inexactos o estén
                  incompletos de acuerdo con el Artículo 16 del RGPD.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Suprimir sus datos personales de acuerdo con el Artículo 17
                  del RGPD.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Limitar el tratamiento de sus datos personales de acuerdo con
                  el Artículo 18 del RGPD.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Solicitar la portabilidad de sus datos de acuerdo con el
                  Artículo 20 del RGPD.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>
                  Oponerse al tratamiento de sus datos personales de acuerdo con
                  el artículo 21 del RGPD.
                </v-list-item-text>
              </v-list-item>
            </p>
          </v-list>
           <p class="font-weight-light primary--text">
            Si ha otorgado su consentimiento para alguna finalidad concreta, tiene derecho a retirar el consentimiento otorgado en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada rrhh.
            <br><br>
            Puede ejercer estos derechos enviando comunicación, motivada y acreditada, a info@ebersy.com
            <br><br>
            También tiene derecho a presentar una reclamación ante la Autoridad de control competente (<a href="https://aepd.es/">www.aepd.es</a>)  si considera que el tratamiento no se ajusta a la normativa vigente.
          </p>
        </v-col>
        <v-col cols="10" class="pa-5"> 
            <h3 class="my-4 primary--text">
            8. INFORMACIÓN LEGAL
          </h3>
          <p class="font-weight-light primary--text">
            Los requisitos de esta Política complementan, y no reemplazan, cualquier otro requisito existente bajo la ley de protección de datos aplicable, que será la que prevalezca en cualquier caso.
            <br><br>
            Esta Política está sujeta a revisiones periódicas y la empresa puede modificarla en cualquier momento. Cuando esto ocurra, le avisaremos de cualquier cambio y le pediremos que vuelva a leer la versión más reciente de nuestra Política y que confirme su aceptación.
          </p>
        </v-col>
        <v-col cols="10" class="pa-5"> </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Politica",
};
</script>

<style scoped>
.hr {
  border-top: 3px solid;
  width: 3vw;
}
</style>